import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import YouTube from 'react-youtube';
import Aspect from '../utils/aspect-wrapper';

const VideosPage = () => (
  <div>
    <Helmet title="Videos" />
    <h1>Let&apos;s Play Legacy of the Stars!</h1>
    <Aspect ratio={16 / 9}>
      <YouTube videoId="QE9A7VDyYSY" opts={{ width: '100%', height: '100%' }} />
    </Aspect>
  </div>
);

export default VideosPage;



// WEBPACK FOOTER //
// ./src/pages/videos.js